export default function convertToF(celsius) {
  return (celsius * 9) / 5 + 32;
}
